import React from 'react';
import { Modal } from 'antd';
import { alternateSignUpCampaignUrl } from 'constants/alternateSignUp';
import './AlternateSignUpDialog.less';

/**
 * Prompts brands to create the campaign on soona instead of Trend.
 *
 * @typedef {{
 *   open: boolean,
 *   onClose: () => void,
 * }} AlternateSignUpDialogProps
 * @type {React.FC<AlternateSignUpDialogProps>}
 */
const AlternateSignUpDialog = ({ open, onClose }) => {
  return (
    <Modal
      visible={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      destroyOnClose
      centered
      width={668}
      wrapClassName="alternate-sign-up-dialog"
    >
      <div className="alternate-sign-up-dialog__card">
        <span className="alternate-sign-up-dialog__badge">Trend is merging with soona</span>
        <div>
          <h2 className="alternate-sign-up-dialog__title">New campaigns now start on soona</h2>
          <p className="alternate-sign-up-dialog__description">
            Trend stopped accepting new campaigns on <strong>October 1, 2026</strong>. Your existing
            campaigns continue exactly as planned, and your next one starts on soona with the same
            creator network.
          </p>
        </div>
        <div className="alternate-sign-up-dialog__actions">
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a
            className="alternate-sign-up-dialog__primary"
            href={alternateSignUpCampaignUrl}
            target="_blank"
            rel="noopener"
          >
            <span>Start this campaign on soona</span>
            <span aria-hidden>→</span>
          </a>
          <button
            type="button"
            className="u-button-reset alternate-sign-up-dialog__secondary"
            onClick={onClose}
          >
            Back to my campaigns
          </button>
        </div>
        <p className="alternate-sign-up-dialog__footer">
          Active campaigns, credits, and your content are all unaffected.
        </p>
      </div>
    </Modal>
  );
};

export default AlternateSignUpDialog;
